import { useState, useEffect } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import apiService from "../../../../../../service/Api";

// Define the shape of a single item from the API
interface CapacityByVenueTypeItem {
  venue_type: string;
  total_capacity: number;
  venue_count: number;
  avg_capacity: number;
}

// Define the API response shape
interface CapacityByVenueTypeResponse {
  data: CapacityByVenueTypeItem[];
}

// Define the shape of the PieChart data
interface PieChartData {
  id: number;
  value: number;
  label: string;
}

export default function VenueCapacityWidget() {
  const [data, setData] = useState<PieChartData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        // Call your apiService
        const result = await apiService.get<CapacityByVenueTypeResponse>(
          "/api/venues/dashboard/capacity-by-venue-type/"
        );

        // Sometimes apiService wraps response in `data`
        const items: CapacityByVenueTypeItem[] =
          result.data?.data ?? result.data;

        // Transform API data into PieChart format
        const chartData: PieChartData[] = items.map((item, index) => ({
          id: index,
          value: item.total_capacity, // or item.avg_capacity
          label: item.venue_type,
        }));

        setData(chartData);
      } catch (error) {
        console.error("Error fetching venue capacity:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Venue Type by Capacity
        </Typography>

        <PieChart
          series={[
            {
              data: data,
              innerRadius: 70,
              outerRadius: 110,
              paddingAngle: 2,
            },
          ]}
          height={302}
        />
      </CardContent>
    </Card>
  );
}
